<mat-form-field class="select-with-search" [appearance]="appearance" [fxFlex]="fxFlex">
  <mat-label>{{ floatLabel }}</mat-label>
  <mat-select
    (openedChange)="searchInputFocus()"
    [(formControl)]="selectedValue"
    [disabled]="disabled"
    [required]="required"
    [multiple]="isMultiple"
    [compareWith]="compareItems"
  >
    <mat-select-trigger *ngIf="underlineArchivedItems && !isMultiple">
      <span class="select-with-search" [class.select-with-search__archived-selected]="selectedValue.value?.archived">
        {{ selectedValue.value?.name ? selectedValue.value.name : null }}
      </span>
      <span class="select-with-search select-with-search__archived-label" *ngIf="selectedValue.value?.archived">
        {{ archivedLabel }}
      </span>
    </mat-select-trigger>

    <div fxLayout="row" fxLayoutAlign="space-between center">
      <input
        class="select-with-search select-with-search__input"
        (keydown)="$event.stopImmediatePropagation()"
        [formControl]="searchValue"
        [placeholder]="searchLabel"
        autocomplete="off"
        #searchInput
        type="text"
        fxFlex="90"
        matInput
      />
      <button mat-icon-button (click)="searchInputFocus(true)">
        <mat-icon class="font-size-18">backspace</mat-icon>
      </button>
    </div>
    <mat-option
      *ngFor="let item of items"
      [class.display-none]="!filteredItemsIds.includes(item.id)"
      [value]="returnValueInObject ? item : item.id"
      [disabled]="disableOptionIf && item[disableOptionIf]"
    >
      <span
        class="word-wrap select-with-search"
        [class.select-with-search__archived-text]="item.archived && underlineArchivedItems"
      >
        {{ item[fieldDisplayedInMatOption] }}
      </span>
      <span
        *ngIf="item.archived && underlineArchivedItems"
        class="select-with-search select-with-search__archived-label"
      >
        {{ archivedLabel }}
      </span>
    </mat-option>
    <div
      *ngIf="!filteredItemsIds.length"
      fxLayout="row"
      fxLayoutAlign="center center"
      class="select-with-search select-with-search__no-items-found"
    >
      <span>{{ noItemsFoundMessage }}</span>
    </div>
  </mat-select>
  <mat-error class="pb-4" *ngIf="selectedValue.hasError('required')">
    {{ errorMessageRequired }}
  </mat-error>
</mat-form-field>
